import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import i18n from '../../i18n';
import { RootState } from '../reducers/rootReducer';
import { printDiscrepancyReport } from '../actions/activePickTour.actions';
import { createToast } from '../actions/toasts.actions';
import { setLoading } from '../actions/loading.actions';

import {  BFF_STORES, BFF_V1,PRINT_DISCREPANCY_REPORT, SAGA_PRINT_DISCREPANCY_REPORT, PICKING_APIGEE_BASE_PATH } from '../../constants';
import { ConfigAuthValues } from '../../types';
import { callAPI } from '../../utils';
import { catchApiErrors, handleApiErrors } from './utils';

const callPrintDiscrepancyReport = (storeId: string, configAuthValues: ConfigAuthValues) =>
  callAPI({
    method: 'POST',
    url: `${configAuthValues.APIGEE_BASE_URL}${PICKING_APIGEE_BASE_PATH}${BFF_V1}${BFF_STORES}/${storeId}${PRINT_DISCREPANCY_REPORT}`,
    data: {},
  });

export function* runPrintDiscrepancyReportSaga(action: ReturnType<typeof printDiscrepancyReport>) {
  const configAuthValues = yield select((state: RootState) => state.config.authValues);

  yield put(setLoading({ sagaName: SAGA_PRINT_DISCREPANCY_REPORT, isLoading: true }));

  try {
    const response = yield call(callPrintDiscrepancyReport, action.payload.storeId, configAuthValues);
    const { errors } = response;
    if (errors && errors.length > 0) {
      yield handleApiErrors(errors);
    } else {
      yield put(createToast({ type: 'success', message: i18n.t('PRINT_REQUEST_SUCCESS') }));
    }
  } catch (error) {
    try {
      const {storeId} = action.payload
      const url = `${PICKING_APIGEE_BASE_PATH}${BFF_V1}${BFF_STORES}/${storeId}${PRINT_DISCREPANCY_REPORT}`
      const method = 'POST';
      const data = {};
      const config = configAuthValues;
      yield catchApiErrors(error, {url, method, data, config, saga: SAGA_PRINT_DISCREPANCY_REPORT});
    } catch (_error) {
      yield catchApiErrors(error);
    }
  }

  yield put(setLoading({ sagaName: SAGA_PRINT_DISCREPANCY_REPORT, isLoading: false }));
}

export default function* watchPrintDiscrepancyReport() {
  yield takeEvery(getType(printDiscrepancyReport), runPrintDiscrepancyReportSaga);
}
